// HKDSE Type C (抒情散文) Quiz Data - Part 1 (C1, C2, C3)
// 系統化分類測驗數據，為後續 Supabase 後端數據遷移做準備

const hkdseTypeCQuizData = {
  // C1: 司馬遷《廉頗藺相如列傳》
  'hkdse-c1-simaqian-lianpo-linxiangru': {
    keyPoints: {
      title: '重點概念',
      questions: [
        {
          id: 'c1-kp-1',
          question: '陶淵明《歸去來辭》的中心思想是什麼？',
          options: [
            'A. 辭官歸隱田園',
            'B. 追求自由生活',
            'C. 厭惡官場生活',
            'D. 以上皆是'
          ],
          correctAnswer: 'D',
          explanation: '陶淵明通過《歸去來辭》表達辭官歸隱田園的決心，追求自由生活，厭惡官場束縛。',
          points: 10
        },
        {
          id: 'c1-kp-2',
          question: '「心為形役」表達了什麼？',
          options: [
            'A. 身心被束縛',
            'B. 身體疲勞',
            'C. 精神痛苦',
            'D. 生活艱難'
          ],
          correctAnswer: 'A',
          explanation: '「心為形役」體現了陶淵明對官場生活的厭惡，認為身心被束縛。',
          points: 10
        },
        {
          id: 'c1-kp-3',
          question: '「雲無心以出岫」體現了什麼？',
          options: [
            'A. 自然之美',
            'B. 自由之樂',
            'C. 田園之趣',
            'D. 歸隱之志'
          ],
          correctAnswer: 'B',
          explanation: '「雲無心以出岫」等意象體現了陶淵明對自由生活的追求。',
          points: 10
        }
      ]
    },
    argumentationMethods: {
      title: '論證手法',
      questions: [
        {
          id: 'c1-am-1',
          question: '陶淵明如何論證歸隱的正確性？',
          options: [
            'A. 通過對比論證',
            'B. 通過比喻論證',
            'C. 通過舉例論證',
            'D. 通過反證法'
          ],
          correctAnswer: 'A',
          explanation: '陶淵明通過官場與田園的對比，突出田園生活的美好。',
          points: 10
        },
        {
          id: 'c1-am-2',
          question: '文章運用了什麼論證結構？',
          options: [
            'A. 總分總',
            'B. 分總分',
            'C. 並列式',
            'D. 遞進式'
          ],
          correctAnswer: 'A',
          explanation: '文章先提出歸隱的決心，然後分層論證，最後總結，採用總分總的結構。',
          points: 10
        }
      ]
    },
    writingTechniques: {
      title: '寫作手法',
      questions: [
        {
          id: 'c1-wt-1',
          question: '文章主要採用什麼文體？',
          options: [
            'A. 抒情散文',
            'B. 議論文',
            'C. 記敘文',
            'D. 說明文'
          ],
          correctAnswer: 'A',
          explanation: '《歸去來辭》是一篇抒情散文，主要抒發個人情感和經歷。',
          points: 10
        },
        {
          id: 'c1-wt-2',
          question: '陶淵明如何增強抒情效果？',
          options: [
            'A. 運用排比句',
            'B. 運用對偶句',
            'C. 運用比喻',
            'D. 以上皆是'
          ],
          correctAnswer: 'D',
          explanation: '陶淵明運用排比句、對偶句、比喻等多種手法增強抒情效果。',
          points: 10
        }
      ]
    },
    rhetoricalDevices: {
      title: '修辭手法',
      questions: [
        {
          id: 'c1-rd-1',
          question: '「雲無心以出岫，鳥倦飛而知還」運用了什麼修辭？',
          options: [
            'A. 對偶',
            'B. 排比',
            'C. 比喻',
            'D. 誇張'
          ],
          correctAnswer: 'A',
          explanation: '這句話運用了對偶修辭，結構工整，意義對應。',
          points: 10
        },
        {
          id: 'c1-rd-2',
          question: '文章中的比喻有什麼作用？',
          options: [
            'A. 增強形象性',
            'B. 突出特點',
            'C. 深化主題',
            'D. 以上皆是'
          ],
          correctAnswer: 'D',
          explanation: '比喻既能增強形象性，又能突出特點，還能深化主題。',
          points: 10
        }
      ]
    }
  },

  // C2: 孟子《魚我所欲也》
  'hkdse-c2-mengzi-fish-desire': {
    keyPoints: {
      title: '重點概念',
      questions: [
        {
          id: 'c2-kp-1',
          question: '王羲之《蘭亭集序》的中心思想是什麼？',
          options: [
            'A. 記述蘭亭雅集',
            'B. 抒發人生感慨',
            'C. 描寫自然美景',
            'D. 以上皆是'
          ],
          correctAnswer: 'D',
          explanation: '王羲之通過《蘭亭集序》記述蘭亭雅集的盛況，抒發對人生的感慨。',
          points: 10
        },
        {
          id: 'c2-kp-2',
          question: '「後之視今，亦猶今之視昔」表達了什麼？',
          options: [
            'A. 人生短暫',
            'B. 時光流逝',
            'C. 歷史循環',
            'D. 以上皆是'
          ],
          correctAnswer: 'D',
          explanation: '這句話表達了王羲之對人生短暫、時光流逝的深刻感慨。',
          points: 10
        },
        {
          id: 'c2-kp-3',
          question: '「固知一死生為虛誕」體現了什麼？',
          options: [
            'A. 生死觀',
            'B. 人生觀',
            'C. 價值觀',
            'D. 以上皆是'
          ],
          correctAnswer: 'D',
          explanation: '這句話體現了王羲之對生死、人生、價值的深刻思考。',
          points: 10
        }
      ]
    },
    argumentationMethods: {
      title: '論證手法',
      questions: [
        {
          id: 'c2-am-1',
          question: '王羲之如何論證人生短暫？',
          options: [
            'A. 通過對比論證',
            'B. 通過比喻論證',
            'C. 通過舉例論證',
            'D. 通過反證法'
          ],
          correctAnswer: 'A',
          explanation: '王羲之通過古今對比，突出人生短暫的主題。',
          points: 10
        },
        {
          id: 'c2-am-2',
          question: '文章運用了什麼論證結構？',
          options: [
            'A. 總分總',
            'B. 分總分',
            'C. 並列式',
            'D. 遞進式'
          ],
          correctAnswer: 'A',
          explanation: '文章先記述雅集，然後抒發感慨，最後總結，採用總分總的結構。',
          points: 10
        }
      ]
    },
    writingTechniques: {
      title: '寫作手法',
      questions: [
        {
          id: 'c2-wt-1',
          question: '文章主要採用什麼文體？',
          options: [
            'A. 記敘文',
            'B. 抒情文',
            'C. 議論文',
            'D. 說明文'
          ],
          correctAnswer: 'A',
          explanation: '《蘭亭集序》是一篇記敘文，主要記述蘭亭雅集的盛況。',
          points: 10
        },
        {
          id: 'c2-wt-2',
          question: '王羲之如何增強記敘效果？',
          options: [
            'A. 運用描寫',
            'B. 運用抒情',
            'C. 運用議論',
            'D. 以上皆是'
          ],
          correctAnswer: 'D',
          explanation: '王羲之運用描寫、抒情、議論等多種手法增強記敘效果。',
          points: 10
        }
      ]
    },
    rhetoricalDevices: {
      title: '修辭手法',
      questions: [
        {
          id: 'c2-rd-1',
          question: '「此地有崇山峻嶺，茂林修竹」運用了什麼修辭？',
          options: [
            'A. 對偶',
            'B. 排比',
            'C. 比喻',
            'D. 誇張'
          ],
          correctAnswer: 'A',
          explanation: '這句話運用了對偶修辭，結構工整，意義對應。',
          points: 10
        },
        {
          id: 'c2-rd-2',
          question: '文章中的描寫有什麼作用？',
          options: [
            'A. 增強形象性',
            'B. 突出特點',
            'C. 深化主題',
            'D. 以上皆是'
          ],
          correctAnswer: 'D',
          explanation: '描寫既能增強形象性，又能突出特點，還能深化主題。',
          points: 10
        }
      ]
    }
  },

  // C3: 荀子《勸學》
  'hkdse-c3-xunzi-learning-encouragement': {
    keyPoints: {
      title: '重點概念',
      questions: [
        {
          id: 'c3-kp-1',
          question: '蘇軾《前赤壁賦》的中心思想是什麼？',
          options: [
            'A. 抒發人生感慨',
            'B. 描寫赤壁美景',
            'C. 表達豁達胸懷',
            'D. 以上皆是'
          ],
          correctAnswer: 'D',
          explanation: '蘇軾通過《前赤壁賦》抒發對人生的深刻感慨，表達豁達的胸懷。',
          points: 10
        },
        {
          id: 'c3-kp-2',
          question: '「哀吾生之須臾」表達了什麼？',
          options: [
            'A. 人生短暫',
            'B. 時光流逝',
            'C. 生命珍貴',
            'D. 以上皆是'
          ],
          correctAnswer: 'D',
          explanation: '這句話表達了蘇軾對人生短暫、時光流逝的深刻感慨。',
          points: 10
        },
        {
          id: 'c3-kp-3',
          question: '「自其變者而觀之」體現了什麼？',
          options: [
            'A. 辯證思維',
            'B. 豁達胸懷',
            'C. 人生態度',
            'D. 以上皆是'
          ],
          correctAnswer: 'D',
          explanation: '這句話體現了蘇軾辯證的思維、豁達的胸懷和積極的人生態度。',
          points: 10
        }
      ]
    },
    argumentationMethods: {
      title: '論證手法',
      questions: [
        {
          id: 'c3-am-1',
          question: '蘇軾如何論證人生哲理？',
          options: [
            'A. 通過對比論證',
            'B. 通過比喻論證',
            'C. 通過舉例論證',
            'D. 通過反證法'
          ],
          correctAnswer: 'A',
          explanation: '蘇軾通過變與不變的對比，闡述辯證的人生觀。',
          points: 10
        },
        {
          id: 'c3-am-2',
          question: '文章運用了什麼論證結構？',
          options: [
            'A. 總分總',
            'B. 分總分',
            'C. 並列式',
            'D. 遞進式'
          ],
          correctAnswer: 'A',
          explanation: '文章先描寫赤壁夜景，然後抒發感慨，最後總結，採用總分總的結構。',
          points: 10
        }
      ]
    },
    writingTechniques: {
      title: '寫作手法',
      questions: [
        {
          id: 'c3-wt-1',
          question: '文章主要採用什麼文體？',
          options: [
            'A. 賦',
            'B. 散文',
            'C. 詩歌',
            'D. 議論文'
          ],
          correctAnswer: 'A',
          explanation: '《前赤壁賦》是一篇賦，主要抒發個人情感和人生感悟。',
          points: 10
        },
        {
          id: 'c3-wt-2',
          question: '蘇軾如何增強抒情效果？',
          options: [
            'A. 運用描寫',
            'B. 運用議論',
            'C. 運用抒情',
            'D. 以上皆是'
          ],
          correctAnswer: 'D',
          explanation: '蘇軾運用描寫、議論、抒情等多種手法增強抒情效果。',
          points: 10
        }
      ]
    },
    rhetoricalDevices: {
      title: '修辭手法',
      questions: [
        {
          id: 'c3-rd-1',
          question: '「清風徐來，水波不興」運用了什麼修辭？',
          options: [
            'A. 對偶',
            'B. 排比',
            'C. 比喻',
            'D. 誇張'
          ],
          correctAnswer: 'A',
          explanation: '這句話運用了對偶修辭，結構工整，意義對應。',
          points: 10
        },
        {
          id: 'c3-rd-2',
          question: '文章中的議論有什麼作用？',
          options: [
            'A. 深化主題',
            'B. 增強說服力',
            'C. 突出重點',
            'D. 以上皆是'
          ],
          correctAnswer: 'D',
          explanation: '議論既能深化主題，又能增強說服力，還能突出重點。',
          points: 10
        }
      ]
    }
  }
};

// Helper functions
export const getTypeCQuizData = () => {
  return hkdseTypeCQuizData;
};

export const getTypeCQuizByType = (textId, categoryType) => {
  const quizData = hkdseTypeCQuizData[textId];
  if (!quizData) return null;

  const categoryData = quizData[categoryType];
  if (!categoryData) return null;

  // Convert questions to match the expected format
  const convertedQuestions = categoryData.questions.map(question => ({
    ...question,
    correct: question.correctAnswer.charCodeAt(0) - 65, // Convert 'A' to 0, 'B' to 1, etc.
    type: 'multiple-choice'
  }));

  return {
    title: categoryData.title,
    questions: convertedQuestions,
    timeLimit: 300, // 5 minutes
    totalPoints: categoryData.questions.reduce((sum, q) => sum + q.points, 0)
  };
};

export default hkdseTypeCQuizData;